/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Page_Meta_TitleInputs */

const en_start_page_meta_title = /** @type {(inputs: Start_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get started | Glider`)
};

const de_start_page_meta_title = /** @type {(inputs: Start_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erste Schritte | Glider`)
};

const pt_br2_start_page_meta_title = /** @type {(inputs: Start_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comece agora | Glider`)
};

const tr_start_page_meta_title = /** @type {(inputs: Start_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlayın | Glider`)
};

const zh_cn2_start_page_meta_title = /** @type {(inputs: Start_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始使用 | Glider`)
};

const zh_hk2_start_page_meta_title = /** @type {(inputs: Start_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始使用 | Glider`)
};

const ko_kr2_start_page_meta_title = /** @type {(inputs: Start_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시작하기 | Glider`)
};

const ru_ru2_start_page_meta_title = /** @type {(inputs: Start_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начать работу | Glider`)
};

const es_419_start_page_meta_title = /** @type {(inputs: Start_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comenzar | Glider`)
};

/**
* | output |
* | --- |
* | "Get started \| Glider" |
*
* @param {Start_Page_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const start_page_meta_title = /** @type {((inputs?: Start_Page_Meta_TitleInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Page_Meta_TitleInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_start_page_meta_title(inputs)
	if (locale === "de") return de_start_page_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_start_page_meta_title(inputs)
	if (locale === "tr") return tr_start_page_meta_title(inputs)
	if (locale === "zh-CN") return zh_cn2_start_page_meta_title(inputs)
	if (locale === "zh-HK") return zh_hk2_start_page_meta_title(inputs)
	if (locale === "ko-KR") return ko_kr2_start_page_meta_title(inputs)
	if (locale === "ru-RU") return ru_ru2_start_page_meta_title(inputs)
	return es_419_start_page_meta_title(inputs)
});